export default "__VITE_ASSET__D5Y$pWZ9__"